/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Disable_Account_HelpInputs */



/**
* | output |
* | --- |
* | "Disabled members can't sign in but keep their seat." |
*
* @param {Team_Manager_Disable_Account_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_disable_account_help = /** @type {((inputs?: Team_Manager_Disable_Account_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Disable_Account_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les membres désactivés ne peuvent pas se connecter mais conservent leur place.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Deaktivierte Mitglieder können sich nicht anmelden, behalten aber ihren Platz.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I membri disattivati non possono accedere ma mantengono la postazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключённые участники не могут войти, но сохраняют своё место.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los miembros desactivados no pueden iniciar sesión, pero conservan su puesto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已停用的成员无法登录，但仍占用席位。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無効にしたメンバーはサインインできませんが、シートは保持されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षम सदस्य साइन इन नहीं कर सकते, लेकिन उनकी सीट बनी रहती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os membros desativados não podem iniciar sessão, mas mantêm o lugar.")
	return /** @type {LocalizedString} */ ("Disabled members can't sign in but keep their seat.")
});